import MyCourses from './MyCourses'

export default MyCourses
